// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* .bdy{
    background: #2e364a;
} */

.timeline{
    margin: 50px auto;
    position: relative;
    max-width: 1200px;
    /* margin: 100px auto; */
}

.contner{
    padding-left: 80px;
    padding-right: 25px;
    /* padding: 10px 50px; */
    position: relative;
    width: 100%;
    /* background: rgba(0,0,0,0.3); */
    animation: movedown  linear forwards;
    opacity: 0;
    z-index: 20;
     
}

@keyframes movedown {
    0%{
        opacity: 1;
        transform: translateY(-30px);
    }
    100%{
        opacity: 1;
        transform: translateY(0px);
    }
}


.contner:nth-child(1){
    animation-delay: 0s;
}

.contner:nth-child(2){
    animation-delay: 1s;
}
.contner:nth-child(3){
    animation-delay: 1s;
}
.contner:nth-child(4){
    animation-delay: 1s;
}

.contner:nth-child(5){
    animation-delay: 1s;
}


.text-box{
    padding:20px 30px ;
    background: #ffffff;
    position: relative;
    border-radius: 6px;
    font-size: 15px;
}

.left-contner{
    left:0;
}

.right-contner{
    left:0;
    /* left:50% */
}

.contner .img{
    position: absolute;
    width: 40px;
    border-radius: 2%;
    /* right: -20px; */
    left: 10px;
    top: 32px;
    z-index: 10;
}
.right-contner .img{
    left: 10px;
    /* left: -20px; */
}

.timeline::after{
    content: '';
    position: absolute;
    width: 6px;
    height: 100%;
    background:#f44c4c;
    top: 0;
    left: 31px;
    /* left: 50%; */
    margin-left: -3px;
    z-index: 0;
    animation: moveline 4s linear forwards;
   
}

@keyframes moveline {
    0%{
        height: 0;
    }
    100%{
        height: 100%;
    }
}


.left-contner-arrow{
    height: 0;
    width: 0;
    position: absolute;
    top: 28px;
    z-index: 1;
    border-right: 15px solid #fff;
        border-left: 0;
        left:-15px;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    /* border-left: 15px solid #fff; */
    /* right: -15px; */
    
}


.right-contner-arrow{
    height: 0;
    width: 0;
    position: absolute;
    top: 28px;
    z-index: 1;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #fff;
    left: -15px;
}

@media screen and (max-width:600px) {
    
    .timeline{
        margin: 50px auto;
    }

    .timeline::after{
        left: 31px;
    }
    .contner{
        width: 100%;
        padding-left: 80px;
        padding-right: 25px;
    }

    .text-box small{
        margin-bottom: 10px;
    }
    .right-contner{
        left:0;
    }
    .left-contner .img, .right-contner .img{
        left: 10px;
    }

    .left-contner-arrow, .right-contner-arrow{
        border-right: 15px solid #fff;
        border-left: 0;
        left:-15px;
    }



}`, "",{"version":3,"sources":["webpack://./src/Admin/pages/timeline.css"],"names":[],"mappings":";;AAEA;;GAEG;;AAEH;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,oCAAoC;IACpC,UAAU;IACV,WAAW;;AAEf;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,sCAAsC;;AAE1C;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,YAAY;IAChB;AACJ;;;AAGA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,6BAA6B;QACzB,cAAc;QACd,UAAU;IACd,kCAAkC;IAClC,qCAAqC;IACrC,kCAAkC;IAClC,kBAAkB;;AAEtB;;;AAGA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,qCAAqC;IACrC,6BAA6B;IAC7B,WAAW;AACf;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,MAAM;IACV;IACA;QACI,UAAU;IACd;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd,UAAU;IACd;;;;AAIJ","sourcesContent":["\n\n/* .bdy{\n    background: #2e364a;\n} */\n\n.timeline{\n    margin: 50px auto;\n    position: relative;\n    max-width: 1200px;\n    /* margin: 100px auto; */\n}\n\n.contner{\n    width: 100%;\n    padding-left: 80px;\n    padding-right: 25px;\n    /* padding: 10px 50px; */\n    position: relative;\n    width: 100%;\n    /* background: rgba(0,0,0,0.3); */\n    animation: movedown  linear forwards;\n    opacity: 0;\n    z-index: 20;\n     \n}\n\n@keyframes movedown {\n    0%{\n        opacity: 1;\n        transform: translateY(-30px);\n    }\n    100%{\n        opacity: 1;\n        transform: translateY(0px);\n    }\n}\n\n\n.contner:nth-child(1){\n    animation-delay: 0s;\n}\n\n.contner:nth-child(2){\n    animation-delay: 1s;\n}\n.contner:nth-child(3){\n    animation-delay: 1s;\n}\n.contner:nth-child(4){\n    animation-delay: 1s;\n}\n\n.contner:nth-child(5){\n    animation-delay: 1s;\n}\n\n\n.text-box{\n    padding:20px 30px ;\n    background: #ffffff;\n    position: relative;\n    border-radius: 6px;\n    font-size: 15px;\n}\n\n.left-contner{\n    left:0;\n}\n\n.right-contner{\n    left:0;\n    /* left:50% */\n}\n\n.contner .img{\n    position: absolute;\n    width: 40px;\n    border-radius: 2%;\n    /* right: -20px; */\n    left: 10px;\n    top: 32px;\n    z-index: 10;\n}\n.right-contner .img{\n    left: 10px;\n    /* left: -20px; */\n}\n\n.timeline::after{\n    content: '';\n    position: absolute;\n    width: 6px;\n    height: 100%;\n    background:#f44c4c;\n    top: 0;\n    left: 31px;\n    /* left: 50%; */\n    margin-left: -3px;\n    z-index: 0;\n    animation: moveline 4s linear forwards;\n   \n}\n\n@keyframes moveline {\n    0%{\n        height: 0;\n    }\n    100%{\n        height: 100%;\n    }\n}\n\n\n.left-contner-arrow{\n    height: 0;\n    width: 0;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-right: 15px solid #fff;\n        border-left: 0;\n        left:-15px;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    /* border-left: 15px solid #fff; */\n    /* right: -15px; */\n    \n}\n\n\n.right-contner-arrow{\n    height: 0;\n    width: 0;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-top: 15px solid transparent;\n    border-bottom: 15px solid transparent;\n    border-right: 15px solid #fff;\n    left: -15px;\n}\n\n@media screen and (max-width:600px) {\n    \n    .timeline{\n        margin: 50px auto;\n    }\n\n    .timeline::after{\n        left: 31px;\n    }\n    .contner{\n        width: 100%;\n        padding-left: 80px;\n        padding-right: 25px;\n    }\n\n    .text-box small{\n        margin-bottom: 10px;\n    }\n    .right-contner{\n        left:0;\n    }\n    .left-contner .img, .right-contner .img{\n        left: 10px;\n    }\n\n    .left-contner-arrow, .right-contner-arrow{\n        border-right: 15px solid #fff;\n        border-left: 0;\n        left:-15px;\n    }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
